var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    stroke: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_2922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5005 23.1429C9.54525 23.1429 6.71102 21.9689 4.62133 19.8792C2.53164 17.7895 1.35767 14.9553 1.35767 12C1.35767 9.04476 2.53164 6.21054 4.62133 4.12084C6.71102 2.03115 9.54525 0.857178 12.5005 0.857178C15.4558 0.857178 18.29 2.03115 20.3797 4.12084C22.4694 6.21054 23.6434 9.04476 23.6434 12C23.6434 14.9553 22.4694 17.7895 20.3797 19.8792C18.29 21.9689 15.4558 23.1429 12.5005 23.1429Z",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3859 19.8857L4.6145 4.11426",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_2922"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.500244)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.ed6978451dbf8e3526b63ab95c121849.svg";
export { ForwardRef as ReactComponent };